/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ export var styles = ['.ubi-k[_ngcontent-%COMP%]{\r\n    margin-top: 20%;\r\n}'];
//# sourceMappingURL=usuario-no-autorizado.component.css.shim.ngstyle.js.map